export const SIMILAR_EXPERIENCES_COUNT = 4;
